import { render, staticRenderFns } from "./coursedog.vue?vue&type=template&id=6a164b2f&"
import script from "./coursedog.vue?vue&type=script&lang=js&"
export * from "./coursedog.vue?vue&type=script&lang=js&"
import style0 from "./coursedog.vue?vue&type=style&index=0&media=screen&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports